import { makeAutoObservable, observable, ObservableSet } from "mobx";
import ApiStore from "./ApiStore";

class FavoriteProjectsStore {
    isLoading = false;
    ApiStore!: ApiStore;
    ids: ObservableSet<number> = observable.set<number>();

    constructor(apiStore: ApiStore) {
        this.ApiStore = apiStore;
        this.ids = observable.set<number>();
        makeAutoObservable(this, {
            ids: observable,
        });
    }

    async getMyFavorites(userId: number) {
        this.isLoading = true;
        const ids = await this.ApiStore.FavoriteProjectApiClient.getFavoriteProjectIds(userId);
        this.ids.replace(ids);
        this.isLoading = false;
    }

    toggle(companyUserId: number, projectId: number) {
        if (this.ids.has(projectId)) {
            this.ids.delete(projectId);
            // Can be used await but not necessary here
            this.ApiStore.FavoriteProjectApiClient.deleteFavoriteProject({
                companyUserId: companyUserId,
                projectId: projectId
            });
        } else {
            this.ids.add(projectId);
            // Can be used await but not necessary here
            this.ApiStore.FavoriteProjectApiClient.addFavoriteProject({
                companyUserId: companyUserId,
                projectId: projectId
            });
        }
    }
}

export default FavoriteProjectsStore;